
import {getAllEquipmentTypeAPI, getAllEquipmentTypeWithPermAPI,updateEquipmentTypeAPI, createEquipmentTypeAPI, deleteEquipmentTypeAPI,getAllEqmtDynamicFormAPI,AddEquipmentDtlsAPI,GetAllEquipmentMainDataDtlsAPI,deleteMachineTypeAPI,GetAllEquipmentRowDtlAPI,UpdateEquipmentRowDtlAPI,GetAllEquipmentHistoryDtlAPI,EquipmentBulkFileUploadAPI} from '../State/endpoints';
import { actions } from 'store/Reducer/actions';

export const actionTypes = {
    EQUIPMENT_TYPE_GET_REQUEST: "EQUIPMENT_TYPE_GET_REQUEST",
    EQUIPMENT_TYPE_GET_RECEIVE: "EQUIPMENT_TYPE_GET_RECEIVE",
    EQUIPMENT_TYPE_GET_FAIL: "EQUIPMENT_TYPE_GET_FAIL",
    EQUIPMENT_TYPE_PERM_POST_REQUEST: "EQUIPMENT_TYPE_PERM_POST_REQUEST",
    EQUIPMENT_TYPE_PERM_POST_RECEIVE: "EQUIPMENT_TYPE_PERM_POST_RECEIVE",
    EQUIPMENT_TYPE_PERM_POST_FAIL: "EQUIPMENT_TYPE_PERM_POST_FAIL",

    EQUIPMENT_TYPE_HIST_POST_REQUEST: "EQUIPMENT_TYPE_HIST_POST_REQUEST",
    EQUIPMENT_TYPE_HIST_POST_RECEIVE: "EQUIPMENT_TYPE_HIST_POST_RECEIVE",
    EQUIPMENT_TYPE_HIST_POST_FAIL: "EQUIPMENT_TYPE_HIST_POST_FAIL",


    EQUIPMENT_DYFORM_GET_REQUEST: "EQUIPMENT_DYFORM_GET_REQUEST",
    EQUIPMENT_DYFORM_GET_RECEIVE: "EQUIPMENT_DYFORM_GET_RECEIVE",
    EQUIPMENT_DYFORM_GET_FAIL: "EQUIPMENT_DYFORM_GET_FAIL",
    EQUIPMENT_DTL_GET_REQUEST: "EQUIPMENT_DTL_GET_REQUEST",
    EQUIPMENT_DTL_GET_RECEIVE: "EQUIPMENT_DTL_GET_RECEIVE",
    EQUIPMENT_DTL_GET_FAIL: "EQUIPMENT_DTL_GET_FAIL",
    EQUIPMENT_MAINDATA_GET_REQUEST: "EQUIPMENT_MAINDATA_GET_REQUEST",
    EQUIPMENT_MAINDATA_GET_RECEIVE: "EQUIPMENT_MAINDATA_GET_RECEIVE",
    EQUIPMENT_MAINDATA_GET_FAIL: "EQUIPMENT_MAINDATA_GET_FAIL",
    EQUIPMENT_ROWDATA_GET_REQUEST: "EQUIPMENT_ROWDATA_GET_REQUEST",
    EQUIPMENT_ROWDATA_GET_RECEIVE: "EQUIPMENT_ROWDATA_GET_RECEIVE",
    EQUIPMENT_ROWDATA_GET_FAIL: "EQUIPMENT_ROWDATA_GET_FAIL",

    BULKEQUIPMENTDATAUPLOAD_GET_REQUEST:"BULKEQMTDTUPLOAD_GET_REQUEST",
    BULKEQUIPMENTDATAUPLOAD_GET_RECEIVE:"BULKEQMTDTUPLOAD_GET_RECEIVE",
    BULKEQUIPMENTDATAUPLOAD_GET_FAIL:"BULKEQMTDTUPLOAD_GET_FAIL",

  };

const requestEquipmentTypeValue= () => ({
    type: actionTypes.EQUIPMENT_TYPE_GET_REQUEST,
});
const receiveEquipmentTypeValue = (payload) => ({
    type: actionTypes.EQUIPMENT_TYPE_GET_RECEIVE,
    payload,
});
const failureEquipmentTypeValue = (payload) => ({
    type: actionTypes.EQUIPMENT_TYPE_GET_FAIL,
    payload,
});

const requestEquipmentPermValue= () => ({
    type: actionTypes.EQUIPMENT_TYPE_PERM_POST_REQUEST,
});
const receiveEquipmentPermValue = (payload) => ({
    type: actionTypes.EQUIPMENT_TYPE_PERM_POST_RECEIVE,
    payload,
});
const failureEquipmentPermValue = (payload) => ({
    type: actionTypes.EQUIPMENT_TYPE_PERM_POST_FAIL,
    payload,
});

const requestEquipmentHistoryValue= () => ({
    type: actionTypes.EQUIPMENT_TYPE_HIST_POST_REQUEST,
});
const receiveEquipmentHistoryValue = (payload) => ({
    type: actionTypes.EQUIPMENT_TYPE_HIST_POST_RECEIVE,
    payload,
});
const failureEquipmentHistoryValue = (payload) => ({
    type: actionTypes.EQUIPMENT_TYPE_HIST_POST_FAIL,
    payload,
});

const requestEquipmentMainDataValue= () => ({
    type: actionTypes.EQUIPMENT_MAINDATA_GET_REQUEST,
});
const receiveEquipmentMainDataValue = (payload) => ({
    type: actionTypes.EQUIPMENT_MAINDATA_GET_RECEIVE,
    payload,
});
const failureEquipmentMainDataValue = (payload) => ({
    type: actionTypes.EQUIPMENT_MAINDATA_GET_FAIL,
    payload,
});
const requestEquipmentRowDataValue= () => ({
    type: actionTypes.EQUIPMENT_ROWDATA_GET_REQUEST,
});
const receiveEquipmentRowDataValue = (payload) => ({
    type: actionTypes.EQUIPMENT_ROWDATA_GET_RECEIVE,
    payload,
});
const failureEquipmentRowDataValue = (payload) => ({
    type: actionTypes.EQUIPMENT_ROWDATA_GET_FAIL,
    payload,
});
const requestEqDynFormValue= () => ({
    type: actionTypes.EQUIPMENT_DYFORM_GET_REQUEST,
});
const receiveEqDynFormValue = (payload) => ({
    type: actionTypes.EQUIPMENT_DYFORM_GET_RECEIVE,
    payload,
});
const failureEqDynFormValue = (payload) => ({
    type: actionTypes.EQUIPMENT_DYFORM_GET_FAIL,
    payload,
});
const requestEqDtlData= () => ({
    type: actionTypes.EQUIPMENT_DTL_GET_REQUEST,
});

const receiveEqDtlData = (payload) => ({
    type: actionTypes.EQUIPMENT_DTL_GET_RECEIVE,
    payload,
});
const failureEqDtlData = (payload) => ({
    type: actionTypes.EQUIPMENT_DTL_GET_FAIL,
    payload,
});

const requestBulkEqtDataUpload= () => ({
    type: actionTypes.BULKEQUIPMENTDATAUPLOAD_GET_REQUEST,
});

const receiveBulkEqtDataUpload= () => ({
    type: actionTypes.BULKEQUIPMENTDATAUPLOAD_GET_RECEIVE,
});

const failureBulkEqtDataUpload= () => ({
    type: actionTypes.BULKEQUIPMENTDATAUPLOAD_GET_FAIL,
});



export const getAllEquipmentDyFormAction = (id) => {
    return async (dispatch) => {
        dispatch(requestEqDynFormValue());
        try {
            const response = await getAllEqmtDynamicFormAPI(id);
            if (response?.status === 200) {
                console.log("my Data Response",response)
                dispatch(receiveEqDynFormValue(response?.data?.data));
                console.log("After Response",response)
            }
        } catch (error) {
            dispatch(failureEqDynFormValue(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
};


export const getAllEquipmentMainDataAction = (EqmtID) => {
    return async (dispatch) => {
        dispatch(requestEquipmentMainDataValue(EqmtID));
        try {
            const response = await GetAllEquipmentMainDataDtlsAPI(EqmtID);
            if (response?.status === 200) {
                console.log("equ action....data",response)
                dispatch(receiveEquipmentMainDataValue(response?.data?.data));
            }
        } catch (error) {
            dispatch(failureEquipmentMainDataValue(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
};

export const getAllEquipmentMainRowDataAction = (RowID) => {
    return async (dispatch) => {
        dispatch(requestEquipmentRowDataValue(RowID));
        try {
            const response = await GetAllEquipmentRowDtlAPI(RowID);
            if (response?.status === 200) {
                console.log("getAllEquipmentMainRowDataAction....data",response)
                dispatch(receiveEquipmentRowDataValue(response?.data?.data));
            }
        } catch (error) {
            dispatch(failureEquipmentRowDataValue(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
};

export const getAllEquipmentHistRowDataAction = (RowID,EqmntID) => {
    return async (dispatch) => {
        dispatch(requestEquipmentHistoryValue(RowID,EqmntID));
        try {
            const response = await GetAllEquipmentHistoryDtlAPI(RowID,EqmntID);
            if (response?.status === 200) {
                console.log("GetAllEquipmentHistoryDtlAPI....data",response)
                dispatch(receiveEquipmentHistoryValue(response?.data?.data));
            }
        } catch (error) {
            dispatch(failureEquipmentHistoryValue(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
};

export const UpdateEquipmentMainRowDataAction = (RowID,payload) => {
    return async (dispatch) => {
        dispatch(requestEquipmentRowDataValue(RowID));
        try {
            const response = await UpdateEquipmentRowDtlAPI(RowID,payload);
            if (response?.status === 200) {
                dispatch(actions.successAlert("Data updated successfully"));
            }
        } catch (error) {
            dispatch(failureEquipmentRowDataValue(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
};

export const getAllEquipmentTypeAction = () => {
    return async (dispatch) => {
        dispatch(requestEquipmentTypeValue());
        try {
            const response = await getAllEquipmentTypeAPI();
            if (response?.status === 200) {
                console.log("equ action....data",response)
                dispatch(receiveEquipmentTypeValue(response?.data?.data));
            }
        } catch (error) {
            dispatch(failureEquipmentTypeValue(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
};

export const getAllEquipmentWithPermissionAction = (payload) => {
    return async (dispatch) => {
        dispatch(requestEquipmentPermValue(payload));
        try {
            const response = await getAllEquipmentTypeWithPermAPI(payload);
            if (response?.status === 200) {
                console.log("equ with permission action....data",response)
                dispatch(receiveEquipmentPermValue(response?.data?.data));
            }
        } catch (error) {
            dispatch(failureEquipmentPermValue(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
};

export const updateEquipmentTypeAction = (id, payload) => {
    return async (dispatch, getState) => {
        dispatch(requestEquipmentTypeValue());
        try {
            const response = await updateEquipmentTypeAPI(id, payload);
            if (response?.status === 200) {
                dispatch(actions.successAlert("Equipment Type updated successfully"));
            }
            const { decodedToken, roles } = getState().token;
            dispatch(getAllEquipmentWithPermissionAction({
                PageNo: 1,
                PageSize: 1000,
                UserEmail: decodedToken['email'],
                UserRoles: JSON.stringify(roles),
            }));
        } catch (error) {
            dispatch(failureEquipmentTypeValue(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                dispatch(actions.errorAlert("Something went wrong, please contact administrator"));
            }
        }
    };
};

export const createEquipmentTypeAction = (payload) => {
    return async (dispatch, getState) => {
        dispatch(requestEquipmentTypeValue());
        try {
            const response = await createEquipmentTypeAPI(payload);
            if (response?.status === 201) {
                dispatch(actions.successAlert("Equipment Type added successfully"));
            }
            const { decodedToken, roles } = getState().token;
            dispatch(getAllEquipmentWithPermissionAction({
                PageNo: 1,
                PageSize: 1000,
                UserEmail: decodedToken['email'],
                UserRoles: JSON.stringify(roles),
            }));
        } catch (error) {
            dispatch(failureEquipmentTypeValue(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                dispatch(actions.errorAlert("Something went wrong, please contact administrator"));
            }
        }
    };
};

export const deleteEquipmentTypeAction = (payload) => {
    return async (dispatch, getState) => {
        dispatch(requestEquipmentTypeValue());
        try {
            const response = await deleteEquipmentTypeAPI(payload);
            if (response?.status === 200) {
                dispatch(actions.successAlert("Equipment Type deleted successfully"));
            }
            const { decodedToken, roles } = getState().token;
            dispatch(getAllEquipmentWithPermissionAction({
                PageNo: 1,
                PageSize: 1000,
                UserEmail: decodedToken['email'],
                UserRoles: JSON.stringify(roles),
            }));
        } catch (error) {
            dispatch(failureEqDtlData(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                dispatch(actions.errorAlert("Something went wrong, please contact administrator"));
            }
        }
    };
};
export const AddEquipmentDetailsAction = (payload,EqmtID) => {
    return async (dispatch) => {
        dispatch(requestEqDtlData(payload));
        try {
            const response = await AddEquipmentDtlsAPI(payload,EqmtID);
            if (response?.status === 201) {
                dispatch(actions.successAlert("Equipment Details added successfully"));
            }
            if (response?.status === 200) {
                dispatch(actions.successAlert("Request for Change for this Equipment created"));
            }
            dispatch(getAllEquipmentMainDataAction(EqmtID));
        } catch (error) {
            dispatch(failureEquipmentTypeValue(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
}

export const DeleteEquipmentMainDataAction = (pkMachTypeDtl,EqmtID,payload) => {
    return async (dispatch) => {
        dispatch(requestEquipmentMainDataValue(EqmtID));
        try {
            const response = await deleteMachineTypeAPI(pkMachTypeDtl,payload);
            if (response?.status === 200) {
                dispatch(actions.successAlert("Equipment details deleted successfully"));
            }
            dispatch(getAllEquipmentMainDataAction(EqmtID));
        } catch (error) {
            dispatch(failureEquipmentMainDataValue(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
};

export const BulkUploadEquipmentDetailsAction = (formData) => async (dispatch) => {
    dispatch(requestBulkEqtDataUpload()); // don't put FormData in the Redux store
    try {
        const response = await EquipmentBulkFileUploadAPI(formData);
        if (response?.status === 200 || response?.status === 201) {
            dispatch(receiveBulkEqtDataUpload(response?.data));
            dispatch(actions.successAlert("Bulk Equipment Details uploaded successfully"));
        }
    } catch (error) {
        dispatch(failureBulkEqtDataUpload(error?.response?.data?.data));
        dispatch(actions.errorAlert(
            error?.response
                ? error.response.data?.errorMessage ?? "Upload failed"
                : "Something went wrong, please contact administrator"
        ));
    }
};

